import React from "react";
// import Loading from "../../components/common/loading";
// import icons from '../../../assets/icon-all';
import { Link } from "react-router-dom";
import ModalManager from "../../components/common/modal/ModalManager";
import TextInput from "../../components/common/inputs/textInput";
import Pagination from "../../components/common/pagination";
import axios from "axios";
import Loading from '../../components/common/loading'
import { formatDistance } from "date-fns";
import NotificationManager from '../../utils/notificationManager';
import ReactPaginate from 'react-paginate';
const columnWidths = [
  1, // 0
  3, // 1
  2, // 2
  5, // 3
  2, // 4
  2, // 5
  4, // 6
  3, // 7
  5, // 8
  2, // 9
  1, // 10
];
const bus = new EventTarget();

export default class DeviceFirmware extends React.Component {

  componentDidMount() {
    
  }
  tableRef = React.createRef();

  state = {
    searchBar: "",
    currentFilter: "",
    connectionFilter: "",
    sortFilter: "",
    lastUpdated: null
  };
  updateDevice = (enclosureSerialNumber) => {
    this.props.getDeviceItemAndData(enclosureSerialNumber);
    this.props.fetchFwStatus(enclosureSerialNumber);
  };
  applyFilters = () => {
    this.setState({
      currentFilter: this.state.searchBar,
    });
  };

  handleRefresh = async () => {
    await this.tableRef.current?.refreshCurrentPage();
    const stamp = new Date();
    this.setState({ lastUpdated: stamp });
    // also refresh the summary tiles
    window.dispatchEvent(new Event("firmware:mutated"));
  };

  render() {
    const {
      devices = [],
      conf = []
    } = this.props.resources;

    const { currentFilter, lastUpdated } = this.state;

    // const filteredDevices = devices.map(d => `${d.deviceName} ${d.enclosureSerialNumber} ${d.modelNumber}`).filter(d => d.toLowerCase().includes(searchBar.toLowerCase()));
    const filteredDevices = devices
      .filter((d) =>
        `${d.deviceName} ${d.enclosureSerialNumber} ${d.modelNumber}`
          .toLowerCase()
          .includes(currentFilter.toLowerCase())
      )
      .filter((d) => {
        if (this.state.connectionFilter === "") {
          return true;
        } else {
          return d.connectionState === this.state.connectionFilter;
        }
      });
    let sortedFilteredDevices;
    const [sortKey, sortDirection] = this.state.sortFilter.split("_");
    if (this.state.sortFilter) {
      sortedFilteredDevices = filteredDevices.sort((a, b) => {
        if (sortKey === "ipAddress") {
          const foundConfA = conf.find(
            (conf) => conf.enclosureSerialNumber == a.enclosureSerialNumber
          );
          const foundConfB = conf.find(
            (conf) => conf.enclosureSerialNumber == b.enclosureSerialNumber
          );
          let ipAddrA;
          let ipAddrB;
          if (foundConfA) {
            if (foundConfA.ipAssign === "dhcp" && foundConfA.dhcpAssignedIp) {
              ipAddrA = foundConfA.dhcpAssignedIp;
            } else if (
              foundConfA.ipAssign === "static" &&
              foundConfA.staticIp
            ) {
              ipAddrA = foundConfA.staticIp;
            }
          } else {
            ipAddrA = "-";
          }
          if (foundConfB) {
            if (foundConfB.ipAssign === "dhcp" && foundConfB.dhcpAssignedIp) {
              ipAddrB = foundConfB.dhcpAssignedIp;
            } else if (
              foundConfB.ipAssign === "static" &&
              foundConfB.staticIp
            ) {
              ipAddrB = foundConfB.staticIp;
            }
          } else {
            ipAddrB = "-";
          }
          if (sortDirection === "asc") {
            if (ipAddrA < ipAddrB) {
              return -1;
            }
            if (ipAddrA > ipAddrB) {
              return 1;
            }
            return 0;
          } else {
            if (ipAddrA > ipAddrB) {
              return -1;
            }
            if (ipAddrA < ipAddrB) {
              return 1;
            }
            return 0;
          }
        } else {
          if (sortDirection === "asc") {
            if (a[sortKey] < b[sortKey]) {
              return -1;
            }
            if (a[sortKey] > b[sortKey]) {
              return 1;
            }
            return 0;
          } else {
            if (a[sortKey] > b[sortKey]) {
              return -1;
            }
            if (a[sortKey] < b[sortKey]) {
              return 1;
            }
            return 0;
          }
        }
      });
    } else {
      sortedFilteredDevices = filteredDevices;
    }
    const sortOptions = [
      { label: "Default", value: "" },
      { label: "Device Name A-Z", value: "deviceName_asc" },
      { label: "Device Name Z-A", value: "deviceName_desc" },
      { label: "Serial Number ↑", value: "enclosureSerialNumber_asc" },
      { label: "Serial Number ↓", value: "enclosureSerialNumber_desc" },
      { label: "IP Address ↑", value: "ipAddress_asc" },
      { label: "IP Address ↓", value: "ipAddress_desc" },
    ];

    return (
      <div style={{ marginTop: "2vh", overflowX: "auto" }}>
        <div className="grid-x ">
          <div className="cell">
              <FirmwareSummary/>
          </div>
          <div className="cell">
            <FirmwareDevices
              ref={this.tableRef}
              history={this.props.history}
              lastUpdated={lastUpdated}
              onRefresh={this.handleRefresh}
              onRefreshed={(stamp) => this.setState({ lastUpdated: stamp })}
            />
          </div>
        </div>
      </div>
    );
  }
}
// keep order from the server, only preserve object identity for unchanged rows
function reconcileById(prev, next){
  const byId = new Map(prev.map(d => [d.enclosureSerialNumber, d]));
  return next.map(n => {
    const p = byId.get(n.enclosureSerialNumber);
    // shallow compare: only primitives you actually render
    if (
      p &&
      p.deviceName === n.deviceName &&
      p.modelNumber === n.modelNumber &&
      p.connectionState === n.connectionState &&
      p.controllerFirmwareVersion === n.controllerFirmwareVersion &&
      p.latestFwVersion === n.latestFwVersion &&
      p.availableUpdate === n.availableUpdate &&
      p.updatePendingFirmware === n.updatePendingFirmware &&
      p.updateStatus === n.updateStatus
    ) {
      return p; // unchanged → keep identity to prevent re-render flicker
    }
    return n;   // changed row → replace
  });
}
// class FirmwareSummary extends React.Component {
class FirmwareSummary extends React.Component {
  state = { loading: true, error: "", summary: null, dark: document.body.classList.contains('dark-mode') };

  componentWillUnmount() {
    window.removeEventListener("firmware:mutated", this.handleMutated);
    this.darkObserver && this.darkObserver.disconnect();
  }

  componentDidMount() {
    axios
      .get("/v2/firmware/summary", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      })
      .then(({ data }) => this.setState({ summary: data, loading: false }))
      .catch(err =>
        this.setState({ error: err.message || String(err), loading: false })
      );
      // this.reload();
      this.handleMutated = () => this.reload();
      window.addEventListener("firmware:mutated", this.handleMutated);
      this.darkObserver = new MutationObserver(() => {
        this.setState({ dark: document.body.classList.contains('dark-mode') });
      });
      this.darkObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  reload = () => {
    // this.setState({ loading: true });
    if (!this.state.summary) this.setState({ loading: true }); // only show spinner on first load

    axios.get("/v2/firmware/summary", {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") }
    })
      .then(({ data }) => this.setState({ summary: data, loading: false }))
      .catch(err =>
        this.setState({ error: err.message || String(err), loading: false })
      );
  }

  /* reusable KPI tile */
  Tile = ({ label, value, pct, color }) => {
    const { dark } = this.state;
    return (
      <div style={tile.wrap(dark)} className="devices-summary-tile">
        <div style={tile.big(dark)}>{value}</div>
        <div style={tile.label(dark)}>{label}</div>
        <div style={{ ...tile.accent, background: color, width: `${100}%` }} />
      </div>
    );
  };

  render() {
    const { loading, error, summary: s } = this.state;
    if (loading) return <p style={st.center}><Loading black /> Loading...</p>;
    if (error)   return <p style={st.center}>⚠️ {error}</p>;

    const total   = s.total || 0;
    const pct     = n => (total ? Math.round((n / total) * 100) : 0);
    const fw      = s.firmware;

    return (
      <div>
        {/* <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"0 0 8px"}}>
          <div
            style={{
              color:"#777",
              display: 'flex',
              alignItems: 'center'
            }}
            onClick={() => {
              this.reload()
            }}
          >
            Last updated {new Date(s.lastCalculated).toLocaleTimeString()}
            <i className="material-icons" style={{}}>refresh</i>
          </div>
          <button className="button secondary" style={{marginBottom:0}} onClick={}>Refresh</button>
        </div> */}
        <div style={st.grid}>
          {this.Tile({ label: "Total PDUs",        value: total,            pct: 100,                 color: "#34495e" })}
          {this.Tile({ label: "Online",            value: s.online,         pct: pct(s.online),      color: "#2ecc71" })}
          {this.Tile({ label: "Offline",           value: s.offline,        pct: pct(s.offline),     color: "#95a5a6" })}

          {this.Tile({ label: "Update available",  value: fw.updateAvailable, pct: pct(fw.updateAvailable), color: "#e67e22" })}
          {this.Tile({ label: "Up-to-date",        value: fw.upToDate,      pct: pct(fw.upToDate),   color: "#27ae60" })}
          {this.Tile({ label: "In progress",       value: fw.inProgress,    pct: pct(fw.inProgress), color: "#3498db" })}
          {this.Tile({ label: "No release yet",    value: fw.notEligible,   pct: pct(fw.notEligible),color: "#7f8c8d" })}
        </div>
      </div>
    );
  }
}


/* ---------- inline styles --------------------------------------------- */
const st = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
    gap: 16,
  },
  center: {
    textAlign: "center",
    margin: "48px 0",
    color: "#555"
  }
};

const tile = {
  wrap: (dark) => ({
    background: dark ? "#424242" : "#fff",
    borderRadius: 3,
    padding: "20px 16px 12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    position: "relative",
    minHeight: 92,
  }),
  big: (dark) => ({
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 1,
    color: dark ? "#f3f3f3" : "#2c3e50",
  }),
  label: (dark) => ({
    fontSize: 13,
    marginTop: 4,
    color: dark ? "#ccc" : "#7f8c8d",
  }),
  accent: {
    position: "absolute",
    left: 0,
    bottom: 0,
    height: 4,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    transition: "width .4s ease",
  }
};


class FirmwareDevices extends React.Component {
  state = {
    loading: true,
    error: "",
    devices: [],
    meta: {},
    /* UI -------------------------------------------------------- */
    page : 1,
    limit: 10,
    search:"", connectionFilter:"", fwFilter:"",
    sortBy:"conn", sortDir:"asc",
    busyIds: new Set(),

    /* selection ------------------------------------------------- */
    selected: new Set(),      // enclosure SN integers
    allFilteredCount: 0,      // server returns this in meta.totalCount
    pageIds: []               // ids visible on current page
  };

  componentDidMount(){ this.fetchPage(1); }

  /* ---------- REST fetch -------------------------------------- */
  fetchPage = (page, {silent=false} = {}) => {
    const { limit, search, connectionFilter:connectionState,
            fwFilter:fwVersion, sortBy, sortDir } = this.state;

    // this.setState({ loading:true, page });
    if (!silent) this.setState({ loading:true, page });
    else this.setState({ page });
    axios.get("/v2/firmware/devices",{
      headers:{Authorization:"Bearer "+localStorage.getItem("token")},
      params:{
        page, limit, search, connectionState, fwVersion, sortBy, sortDir
      }
    }).then(({data})=>{
      const pageIds = data.data.map(d=>d.enclosureSerialNumber);
      // this.setState({
      //   devices:data.data, meta:data.meta, loading:false,
      //   // allFilteredCount:data.meta.totalCount,
      //   allFilteredCount: data.meta.eligibleCount,
      //   pageIds
      // });
        this.setState(prev => ({
          devices: reconcileById(prev.devices, data.data), // only change diffs
          meta: data.meta,
          loading: silent ? prev.loading : false,
          allFilteredCount: data.meta.eligibleCount,
          pageIds: data.data.map(d=>d.enclosureSerialNumber)
        }));
        // notify parent that data is current
        this.props.onRefreshed?.(new Date());
    }).catch(err=>this.setState({error:err.message||String(err),loading:false}));
  };
  refreshCurrentPage = async ({ silent = true } = {}) => {
    await this.fetchPage(this.state.page, { silent });
    this.props.onRefreshed?.(new Date()); // optional if you ever want child->parent
  };
  /* ---------- selection helpers -------------------------------- */
  toggleRow = (sn, selectable=true) => {
    if (!selectable) return;                     // ← bail if not allowed

    this.setState(p=>{
      const sel=new Set(p.selected);
      sel.has(sn)?sel.delete(sn):sel.add(sn);
      return {selected:sel};
    });
  };

  togglePage = () => {
    this.setState(p=>{
      const sel=new Set(p.selected);
      // const allOnPageSelected = p.pageIds.every(id=>sel.has(id));
      // p.pageIds.forEach(id=>{
      // keep only rows that have updateAvailable
      const selectableIds = // also check that they are online
        p.pageIds.filter(id=>{
          // p.devices.find(d=>d.enclosureSerialNumber===id)?.availableUpdate
          const d = p.devices.find(d=>d.enclosureSerialNumber===id);
          return d?.availableUpdate && d?.connectionState==="Connected";
        });

      const allOnPageSelected = selectableIds.every(id=>sel.has(id));
      selectableIds.forEach(id=>{
        allOnPageSelected?sel.delete(id):sel.add(id);
      });
      return {selected:sel};
    });
  };

  selectAllFiltered = () => {
    /* pull ids of *all* filtered rows in one call */
    axios.get("/v2/firmware/devices/ids",{
      headers:{Authorization:"Bearer "+localStorage.getItem("token")},
      params:{
        search:this.state.search,
        connectionState:this.state.connectionFilter,
        fwVersion:this.state.fwFilter,
        requireUpdateAvailable: true
      }
    }).then(({data})=>{
      this.setState({selected:new Set(data.ids)})
      // const eligible = data.ids.filter(
      //   id => this.state.devices.find(d=>d.enclosureSerialNumber===id)?.availableUpdate
      // );
      // this.setState({selected:new Set(eligible)});
    });
  };

  clearSelection = () => this.setState({selected:new Set()});

  /* ---------- batch-update flow -------------------------------- */
  openBatchModal = () => {
    const ids   = [...this.state.selected];
    const list  = this.state.devices.filter(d=>ids.includes(d.enclosureSerialNumber));
    /* naive target: the first device’s latestFwVersion */
    const suggested = list.find(d=>d.latestFwVersion)?.latestFwVersion || "";
    let targetFw = suggested;
    let concurrency = 5;
    ModalManager.confirm(
      `Are you sure you want to update ${ids.length} devices?`,
      `Batch firmware update`,
      "Start Update",
      (submitted, close) => {
        if (submitted) {
          this.submitBatch(ids,null,concurrency,close)
          close();
        }
      }
    )
  };

  submitBatch = async (ids,targetFw,concurrency,close) => {
    const payload = {
      serialNumbers: ids
    }
    try{
      // await axios.post("/v2/firmware/batch",
      //   payload,
      //   { headers:{Authorization:"Bearer "+localStorage.getItem("token")} }
      // );
      // NotificationManager.success(`Queued ${ids.length} devices`);
      // close(); this.clearSelection(); this.fetchPage(this.state.page);
        const { data } = await axios.post("/v2/firmware/batch", payload, {
          headers:{Authorization:"Bearer "+localStorage.getItem("token")}
        });
  
        // 1) Optimistic local mutation using server’s queued list
        const targetBySn = new Map((data.queued||[]).map(q => [q.sn, q.targetFw]));
        this.setState(prev => ({
          devices: prev.devices.map(d =>
            targetBySn.has(d.enclosureSerialNumber)
              ? { ...d,
                  updateStatus: "queuing",
                  updatePendingFirmware: targetBySn.get(d.enclosureSerialNumber),
                  // keep availableUpdate true so the color stays orange until inProgress
                }
              : d
          )
        }));
  
        NotificationManager.success(`Queued ${ids.length} device${ids.length>1?'s':''}`);
  
        // 2) Tell other widgets to refresh (summary will fetch immediately)
        window.dispatchEvent(new Event("firmware:mutated"));
  
        // 3) Poll devices + summary for a short window to catch backend updates
        setTimeout(() => {
          this.startPolling(ids);

        }, 4200);
  
        close();
        this.clearSelection();
    }catch(e){
      NotificationManager.alert(e.message||"Batch failed");
    }
  };

  startPolling = (ids, attempts = 10, intervalMs = 5000) => {
    let n = 0;
    const tick = async () => {
      // stop if component unmounted
      if (!this._mounted) return;
      n += 1;
     await this.fetchPage(this.state.page, { silent: true });     // refresh table
     window.dispatchEvent(new Event("firmware:mutated")); // refresh summary
     if (n < attempts) setTimeout(tick, intervalMs);
   };
   setTimeout(tick, 0);
 }

 componentDidMount(){ this._mounted=true; this.fetchPage(1); }
 componentWillUnmount(){ this._mounted=false; }
  /* ------------ sort / filter / update (single row) ------------ */
  handleSort = key => {
    this.setState(p=>({
      sortBy:key,
      sortDir:p.sortBy===key ? (p.sortDir==="asc"?"desc":"asc") : "asc",
      page:1
    }),()=>this.fetchPage(1));
  };
  applyFilters = ()=>this.fetchPage(1);

  triggerUpdate = (sn,target,offline) => {
    if(offline) return;
    ModalManager.confirm(
      `Update device ${sn} to firmware ${target}?`,
      "Confirm Update","Update",
      async(ok,close)=>{
        if(!ok) return;
        this.setState(p=>({busyIds:new Set(p.busyIds).add(sn)}));
        try{
          await axios.post(`/v2/firmware/devices/${sn}/update`,
            { firmwareVersion:target },
            { headers:{Authorization:"Bearer "+localStorage.getItem("token")}}
          );
          NotificationManager.success(`Firmware update queued for ${sn}`);
          await this.fetchPage(this.state.page, { silent: true });
          window.dispatchEvent(new Event("firmware:mutated"));
        }catch(e){
          NotificationManager.alert(e.message||"Update failed");
        }finally{
          this.setState(p=>{const b=new Set(p.busyIds); b.delete(sn); return{busyIds:b};});
          close();
        }
      }
    );
  };

  /* ------------ small reusable cell ---------------------------- */
  Cell = ({children,flex,bold,center,onClick,style={}})=>(
    <div
      style={{
        flex,padding:"8px 6px",display:"flex",
        alignItems:"center",justifyContent:center?"center":"flex-start",
        fontWeight:bold?600:400,whiteSpace:"nowrap",
        cursor:onClick?"pointer":"default",userSelect:"none",
        ...style
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );


        // <div className={`grid-row header`}>
        //   <div style={{ flex: columnWidths[0] }}></div>
        //   <div style={{ flex: columnWidths[1] }}>Model Number</div>
        //   <div style={{ flex: columnWidths[2] }}>Serial number</div>
        //   <div style={{ flex: columnWidths[3] }}>Device Name</div>
        //   <div style={{ flex: columnWidths[4] }}>IP Address</div>
        //   <div style={{ flex: columnWidths[5] }}>Firmware</div>
        //   <div style={{ flex: columnWidths[6] }}>Firmware Update</div>
        //   {/* <div style={{ flex: columnWidths[9] }}>Last Update</div> */}
        //   <div style={{ flex: columnWidths[10] }}></div>
        // </div>

  /* ------------ table row -------------------------------------- */
  Row = ({d,odd})=>{
    const offline = d.connectionState==="Disconnected";
    // const actionable = d.availableUpdate && !offline && !this.state.busyIds.has(d.enclosureSerialNumber);
    const actionable =
      d.availableUpdate &&
      !offline &&
      d.updateStatus !== 'inProgress' &&
      d.updateStatus !== 'queuing' &&
      !this.state.busyIds.has(d.enclosureSerialNumber);
    // const checked = this.state.selected.has(d.enclosureSerialNumber);

    const selectable = d.availableUpdate;
    const checked = selectable && this.state.selected.has(d.enclosureSerialNumber)


    const statusColor =
      offline? "#7f8c8d" :
      d.updateStatus==="inProgress"? "#3498db" :
      d.availableUpdate? "#e67e22" :
      d.latestFwVersion===d.controllerFirmwareVersion? "#27ae60" : "#7f8c8d";

    return(
      <div 
        className={`grid-row-wrapper ${
          offline ? "disconnected" : "Connected"
        }`}
      >
        <div
          className={`grid-row ${offline ? "disconnected" : "connected"}`}
          style={{
            display:"flex",
            // background:odd?"#fafafa":"#fff",
            background: "white",
            opacity:offline?0.55:1,
            borderBottom:"1px solid #eee"
          }}
        >
          {this.Cell({flex:1,center:true,
            children: offline
              ?<span title="Offline" style={{ color: "maroon"}} >
                <i className="material-icons" style={{ marginLeft: "4px" }}>
                  cloud_off
                </i>
              </span>
              :<span title="Online" style={{ color: "forestgreen"}} >
                <i className="material-icons" style={{ marginLeft: "4px" }}>
                  cloud_done
                </i>
              </span>
          })}
          {this.Cell({
            flex:1,center:true,
            children: <input
              type="checkbox"
              disabled={!selectable}                       // ← blocks click in UI
              checked={checked}
              style={{
                marginBottom: "0px"
              }}
              onChange={()=>this.toggleRow(d.enclosureSerialNumber, selectable)}
            />
          })}

          {this.Cell({
            flex:2,
            children:d.modelNumber,
            onClick:() => {
              this.props.history.push(`/devices/connected/${d.enclosureSerialNumber}`);
            },
            style: { cursor: 'pointer', textDecoration: "underline" }
          })}
          {this.Cell({
            flex:2,
            children:d.enclosureSerialNumber,
            // onClick:() => {
            //   this.props.history.push(`/devices/connected/${d.enclosureSerialNumber}`);
            // }
          })}
          {this.Cell({flex:4,children:d.deviceName})}
          {this.Cell({flex:2,children:d.controllerFirmwareVersion})}
          {this.Cell({flex:2,children:d.latestFwVersion||"-",center:false})}
          {this.Cell({flex:2,center:false,
            children:<span style={{color:statusColor}}>
              {offline
                ?"Offline"
                :d.updateStatus==="inProgress"
                ?`Updating → ${d.updatePendingFirmware}`
                :d.updateStatus==="queuing"
                ?`Queuing → ${d.updatePendingFirmware}`
                :d.availableUpdate
                  ?"Update available"
                  :d.latestFwVersion
                    ?"Up-to-date"
                    :"No release"}
            </span>
          })}
          {this.Cell({flex:2,center:true,
            children: actionable
              ?<button style={{ marginBottom: "0px"}} className="button secondary"
                      onClick={()=>this.triggerUpdate(d.enclosureSerialNumber,d.latestFwVersion,false)}>
                Update
              </button>
              :this.state.busyIds.has(d.enclosureSerialNumber)?"Loading...":"-"
          })}
        </div>
      </div>
    );
  };

  /* ------------ render ----------------------------------------- */
  render(){
    const {loading,error,devices,meta,page,selected,pageIds,allFilteredCount,limit} = this.state;
    const allOnPage = pageIds.every(id=>selected.has(id));
    const partlySelected = !allOnPage && pageIds.some(id=>selected.has(id));

    let summaryText = null;
    const totalCount = typeof meta?.totalCount === "number" ? meta.totalCount : undefined;
    if (typeof totalCount === "number" && !(loading && devices.length === 0)) {
      if (totalCount === 0) {
        summaryText = "Showing 0 of 0 devices";
      } else if (devices.length === 0) {
        summaryText = `Showing 0 of ${totalCount} devices`;
      } else {
        const currentPage = page || 1;
        const pageLimit = limit || devices.length;
        const showingStart = (currentPage - 1) * pageLimit + 1;
        const showingEnd = Math.min(showingStart + devices.length - 1, totalCount);
        summaryText = `Showing ${showingStart}-${showingEnd} of ${totalCount} devices`;
      }
    }

    const hdr=(label,key,flex,center=false)=>(
      <this.Cell flex={flex} center={center} key={key}
        onClick={key&&key!=="blank"?()=>this.handleSort(key):undefined}>
        {label}
        {key&&this.state.sortBy===key? (this.state.sortDir==="asc"?" ▲":" ▼"):""}
      </this.Cell>
    );


    return(
      <div style={styles.card}>
        {/* <h3 style={styles.h3}>Devices</h3> */}
        {this.renderFilterBar()}

        {summaryText && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              color: "#6b7280",
              fontSize: "14px",
              margin: "0 4px 8px",
            }}
          >
            {summaryText}
          </div>
        )}

        {/* header row */}
        {/* <div style={{display:"flex",borderBottom:"2px solid #ddd",background:"#f8f9fa"}}> */}
        <div className="grid-row header" style={{ marginLeft: "4px"}}>
          {hdr("","blank",1)}
          <this.Cell flex={1} center>
            <input
              type="checkbox"
              checked={allOnPage}
              ref={el=>el&&(el.indeterminate=partlySelected)}
              onChange={this.togglePage}
              style={{
                margin: "0px",
              }}
            />
          </this.Cell>
          {hdr("Model Number","model",2)}
          {hdr("Serial Number","serial",2)}
          {hdr("Device Name","devicename",4)}
          {hdr("Firmware","fw",2)}
          {hdr("Latest","latest",2)}
          {hdr("Status","status",2)}
          {hdr("","blank",2,true)}
        </div>

        {loading && <p style={styles.center}>Loading…</p>}
        {error   && <p style={styles.center}>⚠️ {error}</p>}

        {!loading && !error &&
          devices.map((d,idx)=><this.Row key={d.enclosureSerialNumber} d={d} odd={idx%2}/>)
        }
  <div style={{ marginBottom: "30px"}} />
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              breakLabel="..."
              forcePage={page-1}
              pageCount={meta.totalPages}
              onPageChange={({selected}) => {
                this.fetchPage(selected+1)
              }}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName="react-paginate"
              activeClassName="selected"
            />
        {/* {meta.totalPages>1 && (
          <div style={styles.pager}>
            <button style={styles.pageBtn} disabled={page===1} onClick={()=>this.fetchPage(page-1)}>‹</button>
            <span style={{margin:"0 12px"}}>Page {page}/{meta.totalPages}</span>
            <button style={styles.pageBtn} disabled={page===meta.totalPages} onClick={()=>this.fetchPage(page+1)}>›</button>
          </div>
        )} */}
      </div>
    );
  }

  /* separate render for filter bar to keep render() concise */
  renderFilterBar(){
          /* selection banner */
      const {loading,error,devices,meta,page,selected,pageIds,allFilteredCount} = this.state;
      const hasSelection = selected.size>0;

      const banner = hasSelection && (
        <div style={styles.banner}>
          {selected.size} selected&nbsp;
          {selected.size<allFilteredCount && (
            <>
              |&nbsp;
              <button style={styles.linkBtn}
                onClick={this.selectAllFiltered}>
                Select all {allFilteredCount} devices
              </button>
            </>
          )}
          |&nbsp;
          <button style={styles.linkBtn} onClick={this.clearSelection}>Clear</button>
          <button className="button secondary" style={{ margin: "0px", marginLeft: "10px" }} onClick={this.openBatchModal}>
            Update Firmware
          </button>
        </div>
      );

    return (
      <>
      <div className="grid-x ">
        <div className="cell large-6 medium-6 small-12">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <input
              type="text"
              placeholder="Search for model number, device name, or serial number"
              value={this.state.search}
              onChange={(e) => {
                this.setState({ search: e.target.value });
              }}
              style={{
                marginBottom: "0px"
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  this.applyFilters();
                }
              }}
            />
            <span
              className="search-icon-button"
              style={{ margin: "0" }}
              onClick={() => {
                this.applyFilters();
              }}
            >
              <i className="material-icons">search</i>
            </span>
          </div>
        </div>
        <div
          className="cell large-6 medium-6 small-12"
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >

          {/* refresh cluster */}
          <div style={{ display:'flex', alignItems:'center', gap:8, marginLeft:12, cursor: 'pointer' }}
              onClick={this.props.onRefresh}>
            <span style={{ fontSize:12, color:'#6b6b6b' }}>
              Last updated {this.props.lastUpdated ? this.props.lastUpdated.toLocaleTimeString() : "—"}
            </span>
              <i className="material-icons">refresh</i>
          </div>
        </div>
      </div>
      <div className="grid-x" style={{ marginBottom: "10px"}}>
          <div className="cell large-6">
            <div style={{ display: "flex", marginBottom: "" }}>
              <span style={{ marginRight: "20px" }}>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#6b6b6b",
                    // marginBottom: "5px",
                    marginLeft: "3px",
                  }}
                >
                  Filter by
                </div>
                <div
                  style={{
                    display: 'flex'
                  }}
                >
                  <select
                    style={{
                      margin: "0px",
                      marginBottom: "0px",
                      marginRight: "10px"
                    }}
                    onChange={(e) => {
                      this.setState({
                        connectionFilter: e.target.value,
                      }, () => {
                        this.applyFilters()
                      });
                    }}
                  >
                    <option value="">All Status</option>
                    <option label="connected">Connected</option>
                    <option label="disconnected">Disconnected</option>
                  </select>
                  <input
                    // style={styles.input}
                    placeholder="FW filter (e.g. 8.6)"
                    value={this.state.fwFilter}
                    onChange={e=>this.setState({fwFilter:e.target.value})}
                    onKeyDown={e=>e.key==="Enter" && this.applyFilters()}
                  />
                </div>
              </span>
            </div>
          </div>
          {/* <div className="cell large-6" style={{
            display: 'flex',
            marginBottom: "",
            justifyContent: 'flex-end'
          }}>
            <div style={{
              display: 'flex', alignItems: 'flex-end', width: "100%", justifyContent: 'flex-end'
            }}>
              {banner}
            </div>
          </div> */}
          <div className="cell large-6" style={{ display:'flex', justifyContent:'flex-end' }}>
          {/* existing selection banner */}
          {banner}

        </div>
        </div>
      </>
    )
  }
}

/* ---------- inline styles -------------------------------------------- */
const styles={
  card:{borderRadius:12,padding:16,marginTop:24,boxShadow:"0 2px 6px rgba(0,0,0,0.05)"},
  h3:{margin:0,marginBottom:12,fontSize:18,fontWeight:600},
  center:{textAlign:"center",padding:16,color:"#7f8c8d"},
  btn:{padding:"4px 10px",borderRadius:6,background:"#2980b9",color:"#fff",border:"none",cursor:"pointer",fontSize:12},
  btnSmall:{marginLeft:8,padding:"4px 12px",background:"#34495e",color:"#fff",border:"none",borderRadius:6,cursor:"pointer",fontSize:12},
  pager:{display:"flex",justifyContent:"center",alignItems:"center",padding:12},
  pageBtn:{background:"#ecf0f1",border:"none",padding:"4px 10px",borderRadius:2,cursor:"pointer",fontWeight:600},
  filterBar:{display:"flex",alignItems:"center",gap:8,marginBottom:12},
  input:{padding:"6px 8px", minWidth: "150px"},
  select:{padding:"6px 8px",marginBottom: "0px"},

  banner:{background:"#f0f6ff",border:"1px solid #bcd",borderRadius:4,padding:"5px 20px",marginBottom:0,
          display:"flex",alignItems:"center",gap:12,fontSize:14},
  linkBtn:{background:"none",border:"none",color:"#2980b9",cursor:"pointer",textDecoration:"underline",padding:0},
  batchBtn:{marginLeft:"auto",background:"#e67e22",color:"#fff",border:"none",borderRadius:6,padding:"6px 14px",cursor:"pointer"}
};

/* ---------- lightweight modal styles --------------------------------- */
const modal={
  wrap:{background:"#fff",borderRadius:2,padding:24,maxWidth:320},
  lbl :{display:"block",marginTop:16,fontSize:13,color:"#555"},
  inp :{width:"100%",padding:"6px 8px",border:"1px solid #ccc",borderRadius:2,fontSize:13},
  btnBlue:{marginLeft:8,background:"#2980b9",color:"#fff",border:"none",borderRadius:6,padding:"6px 14px",cursor:"pointer"},
  btnGrey:{background:"#bdc3c7",color:"#fff",border:"none",borderRadius:2,padding:"6px 14px",cursor:"pointer"}
};
